import EA from '../helpers/init';

export default EA.Methods.sponsoredDataLayerHandler = ($this) => {
    const SELECTORS = [
        '.app-banner-wrapper',
        '.sidebar-app-banner',
        '.home-sponsored-block',
        '.custom-content-block-outer',
    ];

    const blocks = document.querySelectorAll(SELECTORS.join(', '));

    if(!blocks.length) return;

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if(!entry.isIntersecting) return;

            const el = entry.target;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'sponsored_block_impression',
                sponsored_title: el.querySelector('a').getAttribute('title'), //  neki sadržaj linka
                target_url: el.querySelector('a').getAttribute('href'), // gdje vodi link
                block_position: el.getAttribute('data-position'), // pozicija bloka - ako ima više pozicija na stranici
                page_title: document.title,
                page_location: window.location.href
            });

            console.log('dataLayer: ', window.dataLayer);

            obs.unobserve(el);
        });
    }, {
        threshold: 0.5,
    });

    blocks.forEach((block, index) => {
        block.setAttribute('data-position', index + 1);
        observer.observe(block);
    });
};
